import { P, Price } from '@ahmdigital/ui';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Icon from '@ahmdigital/icons-web';

import { colors } from '../../../../../../../travel-insurance/components/header/components/traveller-details/styles';
import { ProductType } from '../../../../../../../../types/product';
import { RootState } from '../../../../../../../../reducers';
import getCustomerHasChanged from '../../../../../../../../utils/customer-has-changed';
import getFutureDate from '../../../../../../../../utils/get-future-date';
import PriceActions from '../../../../../../../../actions/price';
import PriceService from '../../../../../../../../models/price';
import selectCustomer from '../../../../../../../../selectors/select-customer';
import selectPrices from '../../../../../../../../selectors/select-prices';
import styles from './styles.module.sass';
import truncateFrequency from '../../../../../../../../utils/truncate-frequency';

type IllustrationContentProps = {
  title: string;
  options: string[];
  productId: ProductType['id'];
};

const IllustrationContent = ({ title, options, productId }: IllustrationContentProps) => {
  const dispatch = useDispatch();
  const customer = useSelector(selectCustomer);
  const prices = useSelector(selectPrices);
  const useFutureEffectiveDate = useSelector((state: RootState) => state.price.useFutureEffectiveDate);

  const effectiveDate = getFutureDate(useFutureEffectiveDate);
  const customerHasChanged = getCustomerHasChanged(customer, useFutureEffectiveDate);

  useEffect(() => {
    dispatch(PriceActions.load(productId, {}, { date: effectiveDate }));
  }, [customerHasChanged, dispatch, effectiveDate, productId]);

  const rawPrice = PriceService.getPrice(prices, productId, customer, { date: effectiveDate });
  const price = rawPrice ? PriceService.getAmountAsObject(rawPrice, customer.frequency) : undefined;

  return (
    <div className={styles.container}>
      <P variant={['simpleBit', 'withoutMargin']} className={styles.title}>
        {title}
      </P>
      <Price
        variant="simpleBit"
        className={styles.price}
        frequency={truncateFrequency(customer.frequency)}
        price={price}
        isFrequencyInline
        showAsterisk
      />
      <div className={styles.options}>
        {options.map((option) => (
          <div key={option}>
            <Icon name="tick-circle" fill={colors.green} /> <span>{option}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IllustrationContent;
